import { BsHourglassSplit, BsPlusCircleFill } from 'react-icons/bs';
// import { useState } from 'react';

import './feedbackContainer.css';
import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import axios from 'axios';
import { globalEnv } from '../../../config/baseConfig';
import axiosInstance from '../../../config/axiosInstance';

const queryClient = new QueryClient();
export default function Feedback() {
	return (
		<QueryClientProvider client={queryClient}>
			<FeedbackData />
		</QueryClientProvider>
	);
}

const FeedbackData = () => {
	const [page, setPage] = useState(1);

	async function fetchConversations(page: number) {
		const { data } = await axiosInstance().get(
			`${globalEnv.BASE_URL}/admin/conversation/get-all?page=${page}`
		);
		return data;
	}

	const { data, isFetching, isLoading, isError } = useQuery(
		['conversations', page],
		() => fetchConversations(page),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000,
			cacheTime: 5000
		}
	);

	// Prefetch the next page!
	useEffect(() => {
		if (data == null) return;
		if (page < data.meta.limit) {
			queryClient.prefetchQuery(['conversations', page + 1], () =>
				fetchConversations(page + 1)
			);
		}
	}, [data, page, queryClient]);

	return (
		// <div className="feedback-container">
		// 	<div className="feedback-list">
		// 		<Post
		// 			name="Ada"
		// 			timestamp="one week ago"
		// 			text={`Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit
		//   amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur
		//   adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem
		//   ipsum dolor sit amet consectetur adipisicing elit.`}
		// 		/>
		// 		<Post
		// 			name="Leon"
		// 			timestamp="one week ago"
		// 			text={`Lorem ipsum dolor. `}
		// 		/>
		// 		<Post name="Jill" timestamp="5 days ago" text={`Lorem.`} />
		// 		<Post
		// 			name="Ellie"
		// 			timestamp="4 days ago"
		// 			text={`Lorem ipsum dolor sit amet consectetur adipisicing elit. `}
		// 		/>
		// 		<Post
		// 			name="Chris"
		// 			timestamp="4 days ago"
		// 			text={`Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit
		//   amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur
		//   adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem
		//   ipsum dolor sit amet consectetur adipisicing elit.

		//   Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem
		//   ipsum dolor sit amet consectetur adipisicing elit.`}
		// 		/>
		// 		<Post
		// 			name="Claire"
		// 			timestamp="2 days ago"
		// 			text={`Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit
		//   amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur
		//   adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. `}
		// 		/>
		// 		<Post
		// 			name="Albert"
		// 			timestamp="22 hours ago"
		// 			text={`Lorem ipsum dolor sit amet consectetur adipisicing elit. ☺️ `}
		// 		/>
		// 		<Post
		// 			name="Rebecca"
		// 			timestamp="3 hours ago"
		// 			text={`Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit
		//   amet consectetur adipisicing elit.`}
		// 		/>
		// 		<Post
		// 			name="H.U.N.K"
		// 			timestamp="Just now"
		// 			text={`Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem ipsum dolor sit
		//   amet consectetur adipisicing elit. Lorem ipsum dolor sit amet consectetur
		//   adipisicing elit. Lorem ipsum dolor sit amet consectetur adipisicing elit. Lorem
		//   ipsum dolor sit amet consectetur adipisicing elit.`}
		// 		/>
		// 	</div>

		// 	<BottomBar />
		// </div>

		<div className="flex flex-row w-8/12 mx-auto pt-80 justify-center">
			<h3 className="font-bold text-6xl dark:text-gray-500 text-center mt-2">
				Coming soon
			</h3>

			<BsHourglassSplit className="mt-4" size={60} />
		</div>
	);
};

const BottomBar = () => (
	<div className="bottom-bar">
		<PlusIcon />
		<input
			type="text"
			placeholder="Enter message..."
			className="bottom-bar-input"
		/>
	</div>
);

const Post = ({
	name,
	timestamp,
	text
}: {
	name: string;
	timestamp: string;
	text: string;
}) => {
	const seed = Math.round(Math.random() * 100);
	return (
		<div className={'post'}>
			<div className="avatar-wrapper">
				<img
					src={`https://api.dicebear.com/7.x/bottts/svg?seed=${seed}`}
					alt=""
					className="avatar"
				/>
			</div>

			<div className="post-content">
				<p className="post-owner">
					{name}
					<small className="timestamp">{timestamp}</small>
				</p>
				<p className="post-text">{text}</p>
			</div>
		</div>
	);
};

const PlusIcon = () => (
	<BsPlusCircleFill
		size="22"
		className="text-green-500 dark:shadow-lg mx-2 dark:text-primary"
	/>
);
